var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.advert.link)?_c('div',{staticClass:"advert card",style:(_vm.style)},[_c('a',{attrs:{"href":_vm.advert.link,"target":_vm.advert.target},domProps:{"innerHTML":_vm._s(_vm.advert.text)}})]):_c('div',{staticClass:"advert card",style:(_vm.style)},[_c('a',{attrs:{"target":_vm.advert.target},domProps:{"innerHTML":_vm._s(_vm.advert.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }